// Generated by Claude Code
import { useCallback, useEffect, useState } from 'react'

export interface ExitTransition {
  /** Keep the content mounted: it is active, or its exit is still playing. */
  present: boolean
  /** The exit is playing — active has gone false while the content is still mounted. */
  leaving: boolean
  /** Ends the exit, letting the content unmount. Call it from the animation's own end event. */
  end: () => void
}

/**
 * Keeps content mounted past the moment it stops being active, so its exit animation can play.
 * Nothing unmounts until `end` is called, so where motion is off and no end event fires, the
 * content stays mounted in its resting state.
 */
export function useExitTransition(active: boolean): ExitTransition {
  const [mounted, setMounted] = useState(active)
  const end = useCallback(() => setMounted(false), [])

  useEffect(() => {
    if (active) setMounted(true)
  }, [active])

  return { present: mounted || active, leaving: mounted && !active, end }
}

export default useExitTransition
